import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
  templateUrl: './doc-from-gmail.component.html',
  styleUrls: ['./doc-from-gmail.component.scss']
})
export class DocFromGmailComponent implements OnInit {
  pageTitle: string;
  stepsCreateDocDefaultsSrc = '../../../assets/pdf/create-doc-from-gmail/steps-create-doc-with-defaults.pdf';
  diagramCreateDocDefaultsSrc = '../../../assets/pdf/create-doc-from-gmail/diagram-create-doc-with-defaults.pdf';
  mockCreateDocDefaultsHighlightText = '../../../assets/img/create-doc-from-gmail/mock-create-doc-defaults-highlight-text.png';
  mockCreateDocDefaultsMoreMenu = '../../../assets/img/create-doc-from-gmail/mock-create-doc-defaults-more-menu.png';
  mockNewDocFromGmail = '../../../assets/img/create-doc-from-gmail/mock-new-doc-from-gmail.png';

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.pageTitle = this.route.snapshot.data.pageTitle;
  }
}
